module.exports = __webpack_public_path__ + "static/img/18d.f537ce0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/18d.jpg
// module id = htzT
// module chunks = 0